import axios from "../components/apiRepository/axios";
import { useEffect } from "react";
import useStore from "./useStore";

const useAxiosPrivate = () => {
  const { store } = useStore();
  useEffect(() => {
    const token = store?.token || sessionStorage.getItem("token");
    const requestIntercept = axios.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error),
    );

    const responseIntercept = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (error?.response?.status === 403 && !prevRequest?.sent) {
          prevRequest.sent = true;
          // const newAccessToken = await refresh();
          prevRequest.headers["Authorization"] = `Bearer ${token}`;
          return axios(prevRequest);
        }
        return Promise.reject(error);
      },
    );

    return () => {
      axios.interceptors.request.eject(requestIntercept);
      axios.interceptors.response.eject(responseIntercept);
    };
  }, []);

  return axios;
};

export default useAxiosPrivate;
